// ============================================================================
// REROOTING DP - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'rerooting-dp',
  name: 'Rerooting DP',
  category: 'Graphs',
  complexity: {
    time: 'O(N)',
    space: 'O(N)'
  },
  description: 'A dynamic programming technique on trees that computes DP values for all possible roots efficiently. It performs an initial DFS from an arbitrary root, then a second DFS to reroot and update DP values in O(1) per edge.'
};
